import React, { memo, useEffect, useRef } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { CurrentAmount } from '../../../../containers/common/bettingParts/manualBetSection/currentAmount';
import { globalTranslationKeys } from '../../../../enums';

export const DoBetSection = memo(
  ({
    betAmount,
    index,
    handleDoBetEvents,
    betBtnText,
    disabled,
    isBetAccepted,
    isClosedDoBet,
    isLoaderActive,
    isHalfCashOutOn,
    additionalBtnInfo,
    isHalfCashOuted,
    freeBetRemainingCount,
    isMaxWin,
    isFreeBetMaxWin,
  }) => {
    const t = useTranslation();
    const { CashOut, Cancel, Cashed } = globalTranslationKeys;
    const className =
      CashOut === betBtnText
        ? 'cashout'
        : Cancel === betBtnText
        ? 'cancel'
        : !disabled
        ? ' pulse-anim'
        : '';
    const localRefIsDoBet = useRef();

    useEffect(() => {
      if (!localRefIsDoBet.current && isClosedDoBet) {
        localRefIsDoBet.current = isClosedDoBet;
      }
    }, [isClosedDoBet]);

    return (
      <div className={`crash-bet-action  ${disabled}  ${className} `}>
        <div className='btn-block-cashout'>
          <button
            className={`bet-btn  ${additionalBtnInfo ? 'cashout-top' : ''} `}
            onClick={() => {
              if (localRefIsDoBet.current) return;
              handleDoBetEvents(index);
            }}
            onMouseDown={() => {
              if (localRefIsDoBet.current) {
                localRefIsDoBet.current = false;
              }
            }}
            onKeyDown={(e) => {
              if (disabled) e.preventDefault();
            }}
            title={t(betBtnText)}
          >
            <span>{`${t(betBtnText)} ${freeBetRemainingCount}`}</span>

            {isHalfCashOutOn && isBetAccepted && (
              <CurrentAmount
                betAmount={betAmount}
                index={index}
                isHalfCashOutOn={isHalfCashOutOn || isHalfCashOuted}
                isHalfCashOuted={isHalfCashOuted}
              />
            )}

            {additionalBtnInfo}
          </button>

          {isBetAccepted && isHalfCashOutOn && (
            <button
              className={`bet-btn cashout-50 ${
                isHalfCashOuted || isFreeBetMaxWin || isMaxWin ? 'inactive' : ''
              } `}
              onClick={() => {
                if (localRefIsDoBet.current) return;
                handleDoBetEvents(index, isHalfCashOutOn);
              }}
              onMouseDown={() => {
                if (localRefIsDoBet.current) {
                  localRefIsDoBet.current = false;
                }
              }}
              onKeyDown={(e) => {
                if (disabled) e.preventDefault();
              }}
              title={t(betBtnText)}
            >
              {isHalfCashOuted ? t(Cashed) : t(betBtnText)}
              <p>50%</p>
            </button>
          )}
        </div>
        {isLoaderActive && <span className='circle-loader' />}
        {!isHalfCashOutOn && isBetAccepted && (
          <CurrentAmount betAmount={+betAmount} isHalfCashOuted={isHalfCashOuted} index={index} />
        )}
      </div>
    );
  }
);
